<!-- @format -->

<div class="empty-state">
	<img
		src="{{ data.imgPath }}"
		alt=" icon" />
	<span>{{ data.message1 }}</span>
	<span>{{ data.message2 }}</span>
</div>
